<app-map-edition-geometry
  [webMapId]='configService.Config.mapSpEditId'
  [defaultPointSymbol]='configService.Config.layers.sp.symbol?.point'
  [defaultPolylineSymbol]='configService.Config.layers.sp.symbol?.polyline'
  [defaultPolygonSymbol]='configService.Config.layers.sp.symbol?.polygon'
  [height]='height'
  [graphics]='currentGraphics'
  [readonlyMode]="isReadOnly"
  [filterLayer]="filterLayer"
  (featuresChange)='featuresChanges($event)'></app-map-edition-geometry>
